/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Toolkit_FilesInputs */

const en_pc_alt_t_toolkit_files = /** @type {(inputs: Pc_Alt_T_Toolkit_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In your browser, according to its README`)
};

const zh_pc_alt_t_toolkit_files = /** @type {(inputs: Pc_Alt_T_Toolkit_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你的浏览器中（据其 README）`)
};

/**
* | output |
* | --- |
* | "In your browser, according to its README" |
*
* @param {Pc_Alt_T_Toolkit_FilesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_toolkit_files = /** @type {((inputs?: Pc_Alt_T_Toolkit_FilesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Toolkit_FilesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_toolkit_files(inputs)
	return zh_pc_alt_t_toolkit_files(inputs)
});
export { pc_alt_t_toolkit_files as "pc.alt.t.toolkit.files" }